import states from "./data/states";
import data from "./data/data";
import weekdays from "./data/weekdays"; 

const globalParse = () => {
  // Copying states into states
  for (let x in states) {
    let abbr = states[x];
    states[abbr] = abbr;
  }

  /*
   * Holds global data used in multiple stages of the availability parse
   */

  const cruft = [
    "to",
    "from",
    "empty\\sin",
    "empty",
    "available",
    "AVAILABILITY\\sFOR",
    "AVAILABILITY",
    "UPCOMING",
    "LOAD",
    "TOWARD",
    "LITE",
    "LIGHT",
    "LOOKING",
    "FOR",
    "GOING",
    "LET\\sME\\sKNOW",
    "NEEDS",
    "READY",
    "LOADS",
    "LOAD",
    "BACK",
    "AREA",
    "TEAM",
    "SOLO",
    "ANYWHERE",
    "CLEAN",
    "ODOR",
    "FREE",
    "SINCE",
    "YESTERDAY"
  ];
  const cruftStr = "\\b(" + cruft.join("|") + ")+(\\:|\\s)+";
  const cruftRegEx = RegExp(cruftStr, "ig");
  const simpleCityStateRegEx = /(\w*|\s*),\s*\w\w/;

  return {
    data: data,
    states: states,
    weekdays: weekdays,
    cruft: cruft,
    cruftStr: cruftStr,
    cruftRegEx: cruftRegEx,
    simpleCityStateRegEx: simpleCityStateRegEx
  };
};

export { globalParse };